import Layouts from '@/layouts/main-menu/Main'
import { auth } from '@/middleware'
import VueRouterMultiguard from 'vue-router-multiguard'
import securityAccess from '../../../middleware/securityAccess'

export default [
  {
    path: '/capitalstate',
    component: Layouts,
    beforeEnter: VueRouterMultiguard([auth, securityAccess]),
    redirect: { name: 'capital-state.operacion' },
    meta: {
      access: ['capital-state']
    },
    children: [
      {
        path: 'operacion',
        name: 'capital-state.operacion',
        component: () => import('./views/operacion').then(m => m || m),
        meta: {
          access: ['capital-state.operacion']
        }
      },
      {
        path: 'informe-ejecucion',
        name: 'capital-state.ejecucion',
        component: () => import('./views/ejecucion').then(m => m || m),
        meta: {
          access: ['capital-state.ejecucion']
        }
      }
    ]
  }
]
